<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="24"
    height="20"
    viewBox="114.02198791503906 -846.218017578125 732.1959838867188 732.196044921875"
    fill="none"
  >
    <path
      d="M182.152-114.022q-27.599 0-47.865-20.265-20.265-20.266-20.265-47.865v-595.696q0-27.697 20.265-48.033 20.266-20.337 47.865-20.337h595.696q27.697 0 48.033 20.337 20.337 20.336 20.337 48.033v595.696q0 27.599-20.337 47.865-20.336 20.265-48.033 20.265H182.152Zm0-68.13h595.696v-595.696H182.152v595.696Zm0 0v-595.696 595.696Zm84.565-92.696h427.566q10.054 0 14.722-9.106 4.669-9.106-1.048-18.242l-116.283-156q-5.552-6.717-13.711-6.837-8.159-.119-13.637 6.837L446-305.587l-79.087-108.609q-5.791-6.956-13.95-6.837-8.159.12-13.637 6.837l-85.283 112q-6.717 9.136-2.048 18.242 4.668 9.106 14.722 9.106Zm73.401-291.087q22.576 0 38.262-15.803 15.685-15.803 15.685-38.38 0-22.576-15.803-38.262-15.803-15.685-38.38-15.685-22.576 0-38.262 15.803-15.685 15.803-15.685 38.38 0 22.576 15.803 38.262 15.803 15.685 38.38 15.685Z"
      fill="currentColor"
    />
  </svg>
</template>
